import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import Utils from '../../utils';
import { Context } from '../context';

export default class Popup extends CommonBlock {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showGift: false,
      giftCode: '',
    };
  }

  getCodeBlock = () => {
    if (!this.state.showGift || Utils.getCampaignData(this.props.hideCodeBlock, false)) return null;

    return (<input
      id="wioBlockCode"
      readOnly
      style={{
 bottom: 'calc(10% + 50px)', left: '30%', position: 'absolute', width: '40%',
}}
      value={this.state.giftCode}
    />);
  };

  render() {
    const banClass = Utils.getCampaignData(this.props.emplacement) ? `Wio${Utils.getCampaignData(this.props.emplacement)}` : '';
    const contentStyle = Utils.isStringJson(Utils.getCampaignData(this.props.contentStyle, '')) ? JSON.parse(Utils.getCampaignData(this.props.contentStyle, '')) : {};
    const modalStyle = {
      transition: 'opacity linear 500ms',
      opacity: this.state.closed ? 0 : '',
      display: this.state.closed && this.state.hidden ? 'none' : '',
    };
    if (Utils.getCampaignData(this.props.modalColor, '')) modalStyle.backgroundColor = Utils.getCampaignData(this.props.modalColor, '');

    return (
      <div>
        <div
          id="wio_ban"
          style={this.getStyle()}
          className={`WioFloat ${banClass} WioPopup`}
          onClick={() => {
            if (!Utils.getCampaignData(this.props.exitUrl) || !this.nobutton) return;

            window.WIO.track('acceptBlock', this.props.campaignId, Context[this.props.campaignId].sessionId);
            window.location.href = Utils.getCampaignData(this.props.exitUrl);
          }}
        >
          <div
            id="wioContent"
            style={contentStyle}
            dangerouslySetInnerHTML={{ __html: this.state.content }}
          />
          {this.getCodeBlock()}
          {this.insertAcceptButton()}
          {this.insertDiscoverButton()}
          <button
            id="wioBlockExit"
            style={this.getExitStyle()}
            onClick={this.closeBlock}
          >
            X
          </button>
        </div>
        <div id="WioModal" className="WioModal" style={modalStyle} onClick={this.closeBlock} />
        {this.insertBellButton()}
      </div>
    );
  }
}
